import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["CookieConsent"] */ "/vercel/path0/components/CookieConsent.tsx");
